import React, {Component, PropTypes} from 'react';
import ReactDOM from 'react-dom';

import isTouchDevice from '../../../utils/isTouchDevice';

import zoomerStore from '../../../stores/zoomer';
import mapActions from '../../../actions/map';
import zoomerActions from '../../../actions/zoomer';
import tooltipActions from '../../../actions/tooltip';

export default class SIMSvgPolygon extends Component {

  onMouseEnter () {
    tooltipActions.emit(tooltipActions.EVENTS.HOVER_ENTER, {type: 'section', el: this});
  }

  static onMouseLeave () {
    tooltipActions.emit(tooltipActions.EVENTS.HOVER_LEAVE);
  }

  selectBlock () {
    // TODO, why am I accessing the store directly? performance?
    if (!this.props.static && !zoomerStore.data.clickDisabled && !this.props.isActive) {
      mapActions.emit(mapActions.EVENTS.SECTION_TOGGLE, this.props.sectionId);
      // Zoom to section if we are not selecting a GA section
      if (!this.props.isGA) {
        zoomerActions.emit(zoomerActions.EVENTS.FIT_IN_VIEW, ReactDOM.findDOMNode(this));
      }
    }
  }

  render () {
    var showSeats = this.props.isActive && !this.props.isGA;

    var polygonClass = 'block';
    polygonClass += this.props.isGA ? ' is-ga' : '';
    polygonClass += this.props.available ? ' is-available' : '';
    polygonClass += this.props.isOverviewMode ? ' is-overview' : '';
    polygonClass += this.props.isHighlighted ? ' is-highlighted' : '';
    polygonClass += showSeats ? ' showseats' : '';
    polygonClass += this.props.highlight ? ' highlight' : '';

    var attributes = {
      'data-component':  'svg__section',
      'data-section-id': this.props.sectionId,
      onClick:           this.selectBlock.bind(this),
      className:         polygonClass,
      d:                 this.props.d
    };

    this.props.attributes.forEach(function (attr) {
      attributes['data-' + attr] = '';
    });

    if (!isTouchDevice && !showSeats && !this.props.static) {
      attributes.onMouseEnter = this.onMouseEnter.bind(this);
      attributes.onMouseLeave = SIMSvgPolygon.onMouseLeave;
    }

    return <path {...attributes} />;
  }
}

SIMSvgPolygon.propTypes = {
  d:             PropTypes.string.isRequired,
  isGA:          PropTypes.bool.isRequired,
  isActive:      PropTypes.bool,
  isHighlighted: PropTypes.bool,
  isOverviewMode: PropTypes.bool,
  static:        PropTypes.bool,
  highlight:     PropTypes.bool,
  sectionId:     PropTypes.string.isRequired,
  available:     PropTypes.bool.isRequired,
  attributes:    PropTypes.arrayOf(PropTypes.string).isRequired
};



// WEBPACK FOOTER //
// ./frontend/react/sim/core/components/map/svg/polygon.jsx